import { useEffect, useState } from "react";

export interface IProps {
    url: string;
    style?: React.CSSProperties;
    className?: string;
    alt?: string;
}

export const CachedImage = ({ url, style, className = "", alt = "" }: IProps) => {
    const [src, setSrc] = useState(url);
    const [errored, setErrored] = useState(false);

    useEffect(() => {
        setSrc(url);
        setErrored(false);
    }, [url]);

    return (
        <img
            className={className}
            style={style}
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            onError={() => {
                // harmless cache-bust retry once - not sure if it works but kept it there
                if (!errored) {
                    setErrored(true);
                    const bust = (url.includes("?") ? "&" : "?") + "cb=" + Date.now();
                    setSrc(url + bust);
                }
            }}
        />
    );
};
